import { useTranslation } from "@bounce/i18n"

import type { NavbarProps } from "@/components/Generic/Navbar/Navbar"
import { Product } from "@/types"

import Logo from "@bounce/assets/images/packages/logo-with-text.svg"

export type UseNavbarOptions = Pick<NavbarProps, "languages">

export const useNavbar = ({ languages }: UseNavbarOptions): NavbarProps => {
  const { t } = useTranslation("marketing-pa")

  const navbarProps: NavbarProps = {
    products: [
      {
        id: Product.PackageAcceptance,
        label: t("cmp.packages.navbar.packagePickupV2", "Package pickup"),
        href: "/packages",
      },
      {
        id: Product.LuggageStorage,
        label: t("cmp.packages.navbar.luggageStorageV2", "Luggage Storage"),
        href: "/",
      },
    ],
    Logo,
    links: {
      homepage: { href: "/packages" },
      account: {
        children: t("cmp.packages.navbar.addresses", "My addresses"),
        href: "/packages/reservations",
      },
      auth: { children: t("cmp.packages.navbar.login", "Log in"), href: "/packages/login" },
      desktop: [
        {
          children: t("cmp.packages.navbar.cities", "Cities"),
          href: "/packages#cities",
        },

        {
          children: t("cmp.packages.navbar.whyBounce", "Why Bounce"),
          href: "/packages/social/no-doorman",
        },
        {
          children: t("cmp.packages.navbar.faq", "FAQs"),
          href: "/packages#faq",
        },
      ],
      mobile: [
        {
          children: t("cmp.packages.navbar.cities", "Cities"),
          href: "/packages#cities",
        },

        {
          children: t("cmp.packages.navbar.whyBounce", "Why Bounce"),
          href: "/packages/social/no-doorman",
        },
        {
          children: t("cmp.packages.navbar.faq", "FAQs"),
          href: "/packages#faq",
        },
      ],
    },
    languages,
  }

  return navbarProps
}
